import * as React from 'react';
import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';
import { themeGet, media, Icon, IconNames } from '@packages/ui';

import { ModuleSocialMedia, SocialMediaItem } from '@packages/common';
import { HeadlineWithPaddingBottom } from '../Headline/Headline';
import { List, ListLi, ListUl } from '../../List/List';

export const SocialMediaButton = styled.a`
  display: block;
  width: 43px;
  height: 43px;
  background: ${themeGet.colors('white')};
  box-shadow: -1px 1px 4px 3px rgba(43, 18, 2, 0.1);
  border-radius: 50%;
  padding: 10px;
  color: ${themeGet.colors('primary')};
`;

export const Container = styled.div<SpaceProps>`
  ${space}
  max-width: ${themeGet.content('cmsModuleMaxWidth')};
  margin: 0 auto;

  ${ListUl} {
    list-style-type: none;
    display: flex;
    justify-content: center;
    margin: 0;
  }
  ${ListLi} {
    padding-left: 60px;
    &:first-child {
      padding-left: 0;
    }
  }

  ${media.from.md`
    ${ListLi} {
      padding-left: 144px;
    }
    ${SocialMediaButton as any} {
      width: 112px;
      height: 112px;
      padding: 26px;
    }  
  `};

  ${media.from.xl`
    ${ListLi} {
      padding-left: 80px;
    }
    ${SocialMediaButton as any} {
      width: 80px;
      height: 80px;
      padding: 18px;
    }  
  `};
`;

export type SocialMediaProps = ModuleSocialMedia & {
  onButtonClick?: () => void;
};

export class SocialMedia extends React.PureComponent<SocialMediaProps> {
  renderItem = ({ item }: { item: SocialMediaItem }) => (
    <SocialMediaButton
      key={item.id}
      href={item.url}
      target="_blank"
      rel="nofollow noopener"
      data-testid="cms-social-media-icon"
    >
      <Icon name={`${item.id}Social` as IconNames} />
    </SocialMediaButton>
  );

  render() {
    const { title, items } = this.props;
    return (
      <Container pt={[3, 3, 5]}>
        <HeadlineWithPaddingBottom>{title}</HeadlineWithPaddingBottom>
        <List items={items} renderItem={this.renderItem} />
      </Container>
    );
  }
}
